import { EventsList } from '../../components/Events'

export const Events = () => {
    return <EventsList />
}
